import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Info = ({
  width = 20,
  height = 20,
  className,
  filled = false,
  color,
  decorative = false,
  ariaLabel = "Information",
}: IconProps) => {
  const classes = createColorClasses({ color });
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={filled ? "currentColor" : "none"}
      className={clsx(className, classes)}
      aria-hidden={decorative}
      xmlns="http://www.w3.org/2000/svg"
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M0 10C0 4.47715 4.47715 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10ZM9.3 4H10.8V6H9.3V4ZM10.8 7H9.3V16H10.8V7Z"
      />
    </svg>
  );
};

